import axios from 'axios';

export default class CategoryService {
    doGetCategories(global = '') {
        return axios.get(`/api/categories?global=${global}&language=${language}`);
    }

    doGetCategoryBySlug(slug) {
        return axios.get(`/api/categories/${slug}?language=${language}`);
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/category-service.js